import { AuthenticatedLayout } from "../../../../layouts";
import { FC } from "react";
import { CompletedPaymentTransacitons } from "../../../../components/DirectDeposit/Transactions/CompletedPayment";

export interface ICompletedPaymentTransacitonsPage { }

export const CompletedPaymentTransacitonsPage: FC<ICompletedPaymentTransacitonsPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Completed Payment"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<CompletedPaymentTransacitons />}
		/>
	);
};
